import { DemandStatus } from './../Enuns/demandStatus.enum'
import { ServiceOrderStatus } from './../Enuns/serviceOrderStatus.enum'

export const categoryOptions = Object.entries(DemandStatus).map((cat) => ({
  label: cat[1],
  value: cat[0],
}))

export const serviceOrderStatusOptions = Object.entries(ServiceOrderStatus)
  .filter(([key]) => key !== 'ENTREGUE') // Remove ENTREGUE das opções
  .map((status) => ({
    label: status[1],
    value: status[0],
  }))
